import { useGenres } from "@/apiUtilities/queries/useGenres"
import styles from "./CategorySelector.module.css"
import { useLocale, useTranslations } from "next-intl"
import Pill from "@/components/UI/Buttons/Pill/Pill"
import { useEffect, useState } from "react"
import { useGames } from "@/apiUtilities/queries/useGames"
import GameCard, { CardType } from "@/components/UI/GameCard/GameCard"
import { useWindowSize } from "@/hooks/useWindowsSize"
import ViewMore from "@/components/Rows/ViewMore/ViewMore"
import { useUserStore } from "@/stores/useUserStore"
import { pushToDataLayer } from "@/utils/helpers"

export default function CategorySelector() {

    const locale = useLocale()
    const genres = useGenres(locale)
    const { profileId } = useUserStore()
    const { width } = useWindowSize()
    const [selectedGenre, setSelectedGenre] = useState<string | null>(null)
    const t = useTranslations('CategorySelector')

    const queryString = `locale=${locale}&page=0&size=24${selectedGenre ? `&genre=${selectedGenre}` : ''}`
    const games = useGames({ queryString, enabled: true, profileId })

    const allResults = games.isSuccess ? games.data.pages.flatMap(element => element.games) : []

    // determine columns and number of rows to show (initialLimit = columns * rows)
    let columnsPerRow = 12
    let rowsToShow = 1
    if (width > 1600) {
        columnsPerRow = 12
        rowsToShow = 1
    } else if (width <= 1600 && width > 1280) {
        columnsPerRow = 10
        rowsToShow = 1
    } else if (width <= 1280 && width > 1024) {
        columnsPerRow = 9
        rowsToShow = 2
    } else if (width <= 1024 && width > 768) {
        columnsPerRow = 5
        rowsToShow = 2
    } else {
        columnsPerRow = 4
        rowsToShow = 2
    }

    const initialLimit = columnsPerRow * rowsToShow
    const showViewMore = allResults.length >= initialLimit
    const gameResults = allResults.slice(0, showViewMore ? initialLimit - 1 : initialLimit)

    useEffect(() => {
        if(genres.isSuccess && genres.data.length > 0 && !selectedGenre) {
            setSelectedGenre(genres.data[0].id)
        }
    }   , [genres.isSuccess])

    return (
        <div className={styles.main}>
            <h2 className={`title2 ${styles.title}`}>{t('title')}</h2>
            <div className={styles.categories}>
                {genres.isSuccess && genres.data.map(genre => (
                    <Pill checked={selectedGenre === genre.id} key={genre.id} className={styles.pill} onClick={() => {
                        pushToDataLayer({
                            event: 'genre_search_home',
                            genre_name: genre.name,
                            genre_id: genre.id
                        })
                        setSelectedGenre(genre.id)
                    }}>{genre.name}</Pill>
                ))}
            </div>
            <div className={styles.results}>
                {genres.isSuccess && games.isSuccess && gameResults.map((game, idx) => {
                    return (<GameCard analyticsIndex={idx} analyticsModule={'category_selector'} analyticsRow={selectedGenre!} analyticsRowName={genres.data.find(el => el.id === selectedGenre) ? genres.data.find(el => el.id === selectedGenre)!.name : ''} key={game.game_id} game={game} type={CardType.Vertical}/>)
                })}
                {genres.isSuccess && games.isSuccess && showViewMore && (
                    <ViewMore link={`/catalogue?genre=${selectedGenre}`} row={({ id: selectedGenre ?? 'all', genre: selectedGenre ? { id: selectedGenre, name: '' } : null, content_type: 2, show_more_action: 'search-genre' } as any)} columns={columnsPerRow} />
                )}
            </div>
        </div>)
}